import type { FC } from "react";
import { BsCheckCircle } from "react-icons/bs";

const FeedbackSubmitted: FC = () => {
  return (
    <div className="text-center bg-white p-8 pt-10 rounded-xl">
      <div className="flex justify-center mb-4">
        <span className="flex items-center justify-center p-4 bg-green-100 rounded-full animate-bounce">
          <BsCheckCircle className="w-12 h-12 text-green-600" />
        </span>
      </div>

      <h2 className="mb-2 text-xl font-semibold text-gray-800">
        Feedback Already Submitted
      </h2>
      <p className="text-gray-600">
        Thank you for your valuable feedback. Our team will review your
        submission.
      </p>
    </div>
  );
};
export default FeedbackSubmitted;
